var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OtpDefault',{on:{"get-otp":_vm.getDataPayment,"send-otp":_vm.confirm_otp_for_wap}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }